import Typography from "@mui/material/Typography";
import { getBackgroundJobList } from "@/api/background-job/getBackgroundJobList";
import { formatDateTime } from "@/app/date.utils";

interface JobRunLastRunProps {
  kind: string;
}

/** When a job kind last ran ("Last run 27 Oct 2026, 02:41 · toll/261020"), or "Never run". */
export const JobRunLastRun = (props: JobRunLastRunProps) => {
  const { kind } = props;
  const query = getBackgroundJobList.useQuery({ kind, limit: 1 });
  const last = query.data?.[0];
  let text = "Never run";
  if (last) {
    text = `Last run ${formatDateTime(last.startedAt ?? last.createdAt)}`;
    if (last.subject) text = `${text} · ${last.subject}`;
  }
  if (query.isLoading) text = "…";

  return (
    <Typography
      color="text.disabled"
      variant="body2"
    >
      {text}
    </Typography>
  );
};
